<section class="vh-100">
  <div class="container-fluid h-100">
    <div class="row h-100">
      <div class="col-sm-6 text-black mt-5">
        <div
          class="d-flex align-items-center justify-content-center h-custom-2 px-5 ms-xl-4 mt-5 pt-5 pt-xl-0 mt-xl-n6"
        >
          <form
            style="width: 23rem"
            [formGroup]="loginForm"
            (ngSubmit)="submit()"
          >
            <div class="d-flex justify-content-center">
              <h1 class="mb-5 fw-bold">Track your expenses !</h1>
            </div>
            <div class="form-outline mb-4">
              <input
                type="email"
                class="form-control form-control-lg"
                placeholder="Email address"
                name="email"
                formControlName="email"
              />
              <div
                class="error-container"
                *ngIf="submitted && loginForm.get('email')?.errors"
              >
                <small
                  class="text-danger"
                  *ngIf="loginForm.get('email')?.errors?.required"
                  >Email is required</small
                >
              </div>
            </div>

            <div class="form-outline mb-4">
              <input
                type="password"
                class="form-control form-control-lg"
                placeholder="Password"
                name="password"
                formControlName="password"
              />
              <div
                class="error-container"
                *ngIf="submitted && loginForm.get('password')?.errors"
              >
                <small
                  class="text-danger"
                  *ngIf="loginForm.get('password')?.errors?.required"
                  >Password is required</small
                >
              </div>
              <div
                class="error-container"
                *ngIf="
                  submitted &&
                  error &&
                  loginForm.get('password')?.pristine &&
                  loginForm.get('email')?.pristine
                "
              >
                <small class="text-danger">Please check your credentials</small>
              </div>
            </div>

            <div class="pt-1 mb-4">
              <button
                class="btn btn-primary btn-lg w-100 btn-block"
                type="submit"
                [disabled]="loginForm.invalid || (submitted && !error)"
              >
                Login
              </button>
            </div>

            <div class="small mb-5 pb-lg-2">
              <p
                role="button"
                class="text-muted fit-content-width"
                (click)="redirectToResetPassword()"
              >
                Forgot password?
              </p>
            </div>
            <div>
              Don't have an account?
              <p
                role="button"
                class="fw-bold fit-content-width"
                (click)="redirectToSignup()"
              >
                Register here
              </p>
            </div>
          </form>
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block img-bg"></div>
    </div>
  </div>
</section>
